import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const SEOHead = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language || 'en';

  useEffect(() => {
    // Update document language
    document.documentElement.lang = currentLang;
    
    // Update meta description based on language
    const descriptions = {
      en: 'Grow your business with GlowApp. Complete appointment management solution for beauty salons, spas, and clinics. Book appointments, manage employees, and reach more customers.',
      he: 'גדל את העסק שלך עם GlowApp. פתרון ניהול תורים מקיף למכוני יופי, ספא וקליניקות. הזמן תורים, נהל עובדים והגע ליותר לקוחות.',
      ar: 'نمو عملك مع GlowApp. حل شامل لإدارة المواعيد لصالونات التجميل والمنتجعات الصحية والعيادات. احجز المواعيد وأدر الموظفين ووصل إلى المزيد من العملاء.',
      ru: 'Развивайте свой бизнес с GlowApp. Комплексное решение для управления записями для салонов красоты, спа и клиник. Бронируйте записи, управляйте сотрудниками и привлекайте больше клиентов.',
    };

    const titles = {
      en: 'GlowApp - Book & Manage Appointments | Beauty Business Management Platform',
      he: 'GlowApp - הזמן ונהל תורים | פלטפורמת ניהול עסקי יופי',
      ar: 'GlowApp - احجز وأدر المواعيد | منصة إدارة أعمال الجمال',
      ru: 'GlowApp - Бронируйте и управляйте записями | Платформа управления бизнесом красоты',
    };

    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', descriptions[currentLang] || descriptions.en);

    // Update title
    document.title = titles[currentLang] || titles.en;

    // Update Open Graph tags
    const updateOGTag = (property, content) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };

    updateOGTag('og:title', titles[currentLang] || titles.en);
    updateOGTag('og:description', descriptions[currentLang] || descriptions.en);
    updateOGTag('og:locale', currentLang === 'he' ? 'he_IL' : currentLang === 'ar' ? 'ar_SA' : currentLang === 'ru' ? 'ru_RU' : 'en_US');

    // Update canonical URL with language
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    const baseUrl = process.env.REACT_APP_SITE_URL || 'https://www.glowapp.me';
    const canonicalUrl = currentLang === 'en' ? baseUrl : `${baseUrl}/?lang=${currentLang}`;
    canonical.setAttribute('href', canonicalUrl);
    
    // Update hreflang tags
    const updateHreflang = (lang, href) => {
      let tag = document.querySelector(`link[hreflang="${lang}"]`);
      if (!tag) {
        tag = document.createElement('link');
        tag.setAttribute('rel', 'alternate');
        tag.setAttribute('hreflang', lang);
        document.head.appendChild(tag);
      }
      tag.setAttribute('href', href);
    };
    
    updateHreflang('en', baseUrl);
    updateHreflang('he', `${baseUrl}/?lang=he`);
    updateHreflang('ar', `${baseUrl}/?lang=ar`);
    updateHreflang('ru', `${baseUrl}/?lang=ru`);
    updateHreflang('x-default', baseUrl);
  }, [currentLang]);

  return null;
};

export default SEOHead;
